const selector = {
    ddlBank: '#account_bank',
    accountZr2: '#account_zr_2',
    accountZr3: '#account_zr_3',
    bankUniqueNumber: '#bank-unique-number',
};

export { selector };